import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {FluentProvider} from '@fluentui/react-components';
import {lightTheme} from "./theme/polehlovaTheme";
import {AppWrap} from "./styled/AppWrap";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <FluentProvider theme={lightTheme}>
            <AppWrap>
                <App/>
            </AppWrap>
        </FluentProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
